import { useEffect, useRef, useState } from "react";
import { useResponsiveCount } from "@/lib/useResponsiveCount";

export function useNativeCarousel() {
  const ref = useRef(null);
  const itemsPerView = useResponsiveCount();
  const [canPrev, setCanPrev] = useState(false);
  const [canNext, setCanNext] = useState(false);

  const updateBounds = () => {
    const el = ref.current;
    if (!el) return;
    setCanPrev(el.scrollLeft > 4);
    setCanNext(el.scrollLeft < el.scrollWidth - el.clientWidth - 4);
  };

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    updateBounds();
    el.addEventListener("scroll", updateBounds, { passive: true });
    window.addEventListener("resize", updateBounds);
    return () => {
      el.removeEventListener("scroll", updateBounds);
      window.removeEventListener("resize", updateBounds);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemsPerView]);

  const scrollByStep = (direction) => {
    const el = ref.current;
    if (!el) return;
    const step = el.clientWidth / itemsPerView;
    el.scrollBy({ left: direction * step, behavior: "smooth" });
  };

  return {
    ref,
    itemsPerView,
    canPrev,
    canNext,
    prev: () => scrollByStep(-1),
    next: () => scrollByStep(1),
  };
}
